module.exports = __webpack_public_path__ + "static/media/BarlowSemiCondensed-ExtraBoldItalic.6f63cd49.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/BarlowSemiCondensed-ExtraBoldItalic.ttf
// module id = 3091
// module chunks = 68